
  import ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0 from '/app/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536,
    "xs": 430,
    "xxl": 1920
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "s3.regru.cloud"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "png",
    "jpg",
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0, defaults: {} }
    }
  }
